import { Button, Clickable, Col, H2, H5, P, Row, Section, Strong, Wrapper } from '@ahmdigital/ui';

import Banner from '../../elements/banner';
import Head from '../../../utils/head';
import LegacyBorderedWrapper from '../../components/legacy-bordered-wrapper';
import textStyles from '../../application/common/text.module.sass';

const ExpressedConsentPage = () => (
  <LegacyBorderedWrapper>
    <Head>
      <title>Consent notice</title>
    </Head>
    <div className={textStyles.text}>
      <Banner title="Important information about ahm health insurance and your privacy" />
      <Section>
        <Wrapper>
          <Row>
            <Col sm={12} df={9}>
              <P>
                To help protect your privacy as an ahm member, we’ve hidden your personal information and claims history
                from the principal member on your ahm policy. We want to check if you’d like them to be able to access
                your personal information and claims history online and over the phone.
              </P>
              <H2>What you need to do</H2>
              <P>You have a couple of options:</P>
              <H5>
                If you’d like the principal member to be able to access your personal information and claims history.
              </H5>
              <P>
                Complete this form to give them Personal Information and Claims Consent (PICC). To find out more about
                PICC visit our{' '}
                <Clickable
                  to="https://help.ahm.com.au/hc/en-us/articles/9165363763087-Privacy-consent-and-your-ahm-policy"
                  inNewTab
                >
                  handy help page
                </Clickable>
                .
              </P>
              <Button
                to="https://members.ahm.com.au/personal-info-claims-consent"
                variant={['primary', 'marginTopSpacer10', 'marginBottomSpacer8']}
                inNewTab
              >
                <Strong>Complete the form</Strong>
              </Button>
              <P>OR</P>
              <H5>
                If you want to keep your personal information and claims history private from the principal member.
              </H5>
              <P>
                You don’t need to do a thing! Your details are already hidden. If you change your mind, you can provide
                PICC to the Principal Member at any time.
              </P>
              <H2>Why did you get this SMS?</H2>
              <P>
                The principal member on your ahm policy gave us your contact details so we could get in touch. We’ll
                keep this mobile number on file for you and may use it to send you important information about your ahm
                policy.
              </P>
            </Col>
          </Row>
        </Wrapper>
      </Section>
    </div>
  </LegacyBorderedWrapper>
);

export default ExpressedConsentPage;
